import { render } from "./TopCompetitonsView.vue?vue&type=template&id=4fd54949&scoped=true"
import script from "./TopCompetitonsView.vue?vue&type=script&lang=js"
export * from "./TopCompetitonsView.vue?vue&type=script&lang=js"

import "./TopCompetitonsView.vue?vue&type=style&index=0&id=4fd54949&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd54949"]])

export default __exports__